import api from "actions/api";
import doRequest from "actions/doRequest";
import { NotifyContext, UserContext } from "context";
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import dateUtils from "utils/dateUtils";
import { calendarWrapper, calendar, calendarHeader, calendarBody, calendarCellTitle } from "./ApplicationsCalendar.module.css";
import CalendarCell from "./CalendarCell";
import CalendarHeader from "./CalendarHeader";
import { initCalendar, DAYS, MONTHS, calendarDaysType } from "./calendarUtils";

const ApplicationsCalendar = ({ tabState, setTabState, intl, ...props }) => {
  const translates = useMemo(
    () => ({
      applicationsTab: intl.formatMessage({ id: "msg.tabMenu.applications" }),
      unloading: intl.formatMessage({ id: "ordertype.unloading" }),
      uploading: intl.formatMessage({ id: "ordertype.uploading" }),
      approved: intl.formatMessage({ id: "ordertype.approved" }),
      notApproved: intl.formatMessage({ id: "ordertype.notApproved" }),
      tonsShort: intl.formatMessage({ id: "other.units.tonsShort" }),
    }),
    [intl]
  );

  const { logout } = useContext(UserContext)
  const { pushNotify } = useContext(NotifyContext)
  
  const setTab = (tab) => {
    setTabState((tabState) => ({ ...tabState, tab }));
  };
  useEffect(() => {
    setTabState({
      ...tabState,
      menuList: [
        {
          id: 6,
          popUpText: translates.applicationsTab,
          iconName: "list",
          actions: { onClick: () => setTab(1) },
        },
      ],
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const [currentDate, setCurrentDate] = useState({date:new Date()})
  const [days, setDays] = useState([])

  const clickDayHandler = useCallback(
    (day) => {
      if(day.type!==calendarDaysType.MOCK){
        setTabState({tab:3, menuList:[], editCalendarDay: day.id})
      }
     },
    [setTabState],
  )

  useEffect(() => {
    const fetchDaysData = () => { 
      const daysTonnage = doRequest(api.completedGrainOperationsData.getCalendarDaysData(currentDate.date), pushNotify, logout).ready
      const blockedDays = doRequest(api.blockedDays.list(), pushNotify, logout).ready
      return Promise.all([daysTonnage, blockedDays]).then(res=>{return {daysTonnageData:res[0], blockedDaysData: res[1]}}).catch(e=>console.log(e))
    }

    fetchDaysData().then( ({blockedDaysData, daysTonnageData}) =>{
      const days = initCalendar({date:currentDate.date, daysTonnage:daysTonnageData.waybillsTonnage, blockedDays:blockedDaysData.blockedDays, clickDayHandler})
      setDays(days)
    })
  }, [currentDate, clickDayHandler, pushNotify, logout])
  
  const prevMonth = () => { 
      const day = "01"
      const month = dateUtils.getPrevMonth(currentDate.date)
      const year = currentDate.date.getMonth() === 0 ? dateUtils.getPrevYear(currentDate.date) : currentDate.date.getFullYear()
      setCurrentDate({date:new Date(`${year}-${month}-${day}`)})
   }
  const nextMonth = () => { 
    const day = "01"
    const month = dateUtils.getNextMonth(currentDate.date)
    const year = currentDate.date.getMonth() === 11 ? dateUtils.getNextYear(currentDate.date) : currentDate.date.getFullYear() 
    setCurrentDate({date:new Date(`${year}-${month}-${day}`)})
   }


   const prevYear = () => { 
    const day = "01"
    const month = dateUtils.getMonth(currentDate.date)
    const year = dateUtils.getPrevYear(currentDate.date)
    setCurrentDate({date:new Date(`${year}-${month}-${day}`)})
 }
const nextYear = () => { 
  const day = "01"
  const month = dateUtils.getMonth(currentDate.date)
  const year =  dateUtils.getNextYear(currentDate.date)
  setCurrentDate({date:new Date(`${year}-${month}-${day}`)})
 }
   
const formatTitle = (date) => { 
  const year = date.getFullYear();
  const month = intl.formatMessage({ id: MONTHS[date.getMonth()].translatePath })
  return `${month.toLowerCase()} ${year} ${intl.formatMessage({ id: "other.yearShort" })}.`
 }
  
  return (
    <div className={calendarWrapper}>
      <div className={calendar}>
        <CalendarHeader className={calendarHeader} prevMonth={prevMonth} nextMonth={nextMonth} prevYear={prevYear} nextYear={nextYear} title={formatTitle(currentDate.date)} />
        <div className={calendarBody}>
        {DAYS.map(dayHeader=><div className={calendarCellTitle} key={dayHeader.value}>{intl.formatMessage({ id: dayHeader.translatePath })}</div>)}
        {days.map(day=><CalendarCell key={day.id} header={day.day} dayType={day.type} uploading={day.uploading} unloading={day.unloading}
        unloadingApproved={day.unloadingApproved} uploadingApproved={day.uploadingApproved} unloadingNotApproved={day.unloadingNotApproved} uploadingNotApproved={day.uploadingNotApproved}
        onClick={()=>clickDayHandler(day)}
        translates={translates}
        />)}
        </div>
      </div>
    </div>
  );
};

export default ApplicationsCalendar;
